module.exports = __webpack_public_path__ + "img/sert1.2df54e6d.jpg";